import { CtCatalogueProduct } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'

export const model = {
    id: {
      field: 'id',
      label: 'ID',
      validator: () => true,
      type: 'string',
      required: true
    },
    catalogue: {
      field: 'catalogue',
      label: 'Catalogue',
      validator: () => true,
      type: 'string',
      required: true
    },
    sku: {
      field: 'sku',
      label: 'Stock Keeping Unit (sku)',
      validator: () => true,
      type: 'string',
      required: false
    },
    title: {
      field: 'title',
      label: 'Title',
      validator: () => true,
      type: 'string',
      required: false
    },
    price: {
      field: 'price',
      label: 'Price',
      validator: () => true,
      type: 'string',
      required: false
    },
    active: {
      field: 'active',
      label: 'Active',
      validator: () => true,
      type: 'boolean',
      required: false
    },
    images: {
      field: 'images',
      label: 'Images',
      validator: () => true,
      type: 'string',
      required: false
    }
  }

// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtCatalogueProduct>(
  ContentType.CatalogueProduct, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
